module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("微信扫码联系客服")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "50px auto"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/contact.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("客服电话")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("\n      400 088 3316\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce7d576","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login/contact.vue
// module id = 670
// module chunks = 0